<div class="px-5 pb-5">
  <h1 class="cbb-page-title mb-4">Datos geográficos</h1>
  <app-datos-geograficos-cemento-tabla></app-datos-geograficos-cemento-tabla>
</div>
